import { Address, ContactList, Firm, Person, RegistryType } from "../../backend-definitions.module";

export class Supplier {
    id: number;
    name: string;
    alias: string;
    document: string;
    firm: Firm;
    person: Person;
    registryType: RegistryType;
    address: Address;
    contactList: ContactList;
    bankDetail: any;
    active: boolean;
}
